/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 
import { Message } from 'view-design';
// 通用 Module 
const state = {
  company: null, // 公司信息
}
const mutations = {
  setCompany(state, data) {
    state.company = data;
  },
}
const getters = {
  getCompany: state => {
    return state.company;
  },
}
const actions = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 